import ImageDoneStamp from '../../organisms/user_tutorial_completions/images/done_stamp.svg';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import React, { useContext } from 'react';
import './userTutorialCard.module.scss';
import { userTutorialDetailTexts } from '../../atoms/user_tutorial/UserTutorialDetailTexts';
import { UserTutorialCompletionKey } from '../../../types/userTutorialCompletions';
import { UserTutorialCompletionContext } from '../../../contexts/userTutorialCompletion';

export const UserTutorialCard = ({ page_key }) => {
    const pageContext = useContext(UserTutorialCompletionContext);
    const { resource } = pageContext;
    const hasCompleted = resource.hasCompleted(page_key);
    const { image, title } = userTutorialDetailTexts(page_key);
    const buttonType = hasCompleted ? 'normal' : 'primary';
    const buttonText = hasCompleted ? 'もう一度見る' : '詳細を見る';
    return (
        <div styleName="tutorial-card-wrapper">
            <div styleName="tutorial-card" id={page_key}>
                {hasCompleted && <img id="completed-tutorial" src={ImageDoneStamp} styleName="card-stamp" />}
                <img src={image} styleName="number" />
                <div styleName="tutorial-card-contents">
                    <div styleName="tutorial-card-text">{title}</div>
                    <div styleName="tutorial-card-action">
                        {page_key !== UserTutorialCompletionKey.KEY_FIRST_LOGIN && (
                            <Button
                                onClick={() => GlobalStatesV3.routing.push(V3Routes.userTutorialDetail(page_key))}
                                type={buttonType}
                                styleName="detail-button"
                                id="detail-button"
                                size={'s'}
                            >
                                {buttonText}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
